module.exports = __webpack_public_path__ + "img/vote.ade66e06.svg";